import React from 'react'

const Document = () => {
  return (
    <svg
      fill='none'
      viewBox='0 0 25 26'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M22 1.5a2 2 0 012 2v15.025a5.975 5.975 0 01-5.975 5.975H3a2 2 0 01-2-2v-19a2 2 0 012-2h19z'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
      />
      <path
        d='M19 24.42V20.5a1 1 0 011-1h3.92M4 7.5h17M4 11.5h17M4 15.5h17M4 19.5h11M7 4.5v17'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default Document
